/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import AccountSubMenu from 'bundles/composable-page-header/components/mobile-menu-items/AccountSubMenu';
import LanguageTranslationSubMenu from 'bundles/composable-page-header/components/mobile-menu-items/LanguageTranslationSubMenu';
import type {
  DegreeForProgramSwitcher as Degree,
  ThirdPartyOrganizationForProgramSwitcher as ThirdPartyOrganization,
} from 'bundles/composable-page-header/components/program-switcher/types';
import OrganizationList from 'bundles/composable-page-header/components/user-experience-switcher/OrganizationList';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import getDefaultAccountDropdownLinks from 'bundles/composable-page-header/utils/getDefaultAccountDropdownLinks';

type Props = {
  hasEnrolledPrograms?: boolean;
  naptimeManagedThirdPartyOrganizations?: Array<{ slug: string; name: string }> | null;
  canViewEducatorAdminLink?: boolean;
  hasCheatingIncidents?: boolean;
  courseId?: string;
  currentOrganization?: ThirdPartyOrganization | null;
  currentDegree?: Degree | null;
  degrees?: Degree[] | null;
  organizations?: ThirdPartyOrganization[] | null;
};

const AccountMenuConfig = ({
  hasEnrolledPrograms,
  naptimeManagedThirdPartyOrganizations,
  canViewEducatorAdminLink,
  hasCheatingIncidents,
  courseId,
  currentOrganization,
  currentDegree,
  degrees,
  organizations,
}: Props) => {
  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.LANGUAGE_MENU]: <LanguageTranslationSubMenu currentCourseId={courseId} />,
      }}
    >
      <OrganizationList
        organizations={organizations}
        degrees={degrees}
        currentDegree={currentDegree}
        currentOrganization={currentOrganization}
      />
      <AccountSubMenu
        dropdownLinks={getDefaultAccountDropdownLinks({
          isDegreeOrEnterpriseLearner: !!hasEnrolledPrograms,
          managedThirdPartyOrganizations: naptimeManagedThirdPartyOrganizations,
          canViewEducatorAdminLink,
          hasCheatingIncidents,
        })}
      />
    </MobileMenuConfigWrapper>
  );
};

export default AccountMenuConfig;
